import { render, staticRenderFns } from "./MachinesCommentForm.vue?vue&type=template&id=0da0be5c&"
import script from "./MachinesCommentForm.vue?vue&type=script&lang=js&"
export * from "./MachinesCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports